import { render, staticRenderFns } from "./YagiChatBot.vue?vue&type=template&id=764ff614&scoped=true"
import script from "./YagiChatBot.vue?vue&type=script&lang=js"
export * from "./YagiChatBot.vue?vue&type=script&lang=js"
import style0 from "./YagiChatBot.vue?vue&type=style&index=0&id=764ff614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764ff614",
  null
  
)

export default component.exports